import { Team__Omega } from "../teams/Omega";
import { Team__Potras } from "../teams/Potras";
import { Team__UTPaquime } from "../teams/UTPaquime";

const Omega = {
  team: Team__Omega,
  playingPlayers: [],

  goals: 40,
  penaltyGoals: 0,
  isWinner: false,
};

const Potras = {
  team: Team__Potras,
  playingPlayers: [],

  goals: 16,
  penaltyGoals: 0,
  isWinner: false,
};

const Potras_2 = {
  team: Team__Potras,
  playingPlayers: [],

  goals: 20,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UTPaquime,
  playingPlayers: [],

  goals: 18,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada4 = {
  jornadaPosition: 4,
  matches: [
    {
      team1: Omega,
      team2: Potras,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2026-07-30",
      time: "11:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Potras_2,
      team2: UTPaquime,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2026-07-30",
      time: "16:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
